"use client";

import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import Link from "next/link";

import { getCategoryVariable, useT } from "@/context/I18nContext";
import { useIsLoggedIn } from "@/utlis/useIsLoggedIn";
import { usePWA } from "@/utlis/usePWA";
import Image from 'next/image';

export default function CategoriesShowcase() {
	const [allCategories, setAllCategories] = useState([]);
	const isLoggedIn = useIsLoggedIn();
	const isPWA = usePWA();
	const { t } = useT();

	useEffect(() => {
		fetch("/api/categories")
			.then((res) => res.json())
			.then((data) => setAllCategories(data.categories || []))
			.catch(() => setAllCategories([]));
	}, []);

	// /api/categories2 (folosit de restul homepage-ului) arata doar categoriile
	// cu produse vizibile - aici vrem TOATE categoriile, indiferent de stoc,
	// de-aia fetch separat din /api/categories.
	const list = allCategories.filter((cat) => cat?.image);

	if (!list.length) return null;

	return (
		<section className='cs-section'>
			<style jsx>{`
				.cs-section {
					padding: 0;
				}

				/* ===== TOP SWIPER (1:1 din emag-ui-copy.html, breakpoint mobil) ===== */

				.cs-swiper {
					width: calc(100% + 28px);
					margin-left: -14px;
					padding: 0 14px 24px;
					overflow: visible;
				}

				.cs-card {
					width: calc((100vw - 28px - 20px) / 3);
					min-width: 105px;
					height: 245px;

					border-radius: 14px;
					background: #ffffff;

					display: flex;
					flex-direction: column;
					justify-content: space-between;
					overflow: hidden;

					text-decoration: none;
				}

				.cs-visual {
					height: 120px;
					padding: 10px 5px 0;

					display: grid;
					place-items: center;
					position: relative;
				}

				.cs-title {
					min-height: 63px;
					padding: 3px 5px 13px;

					display: flex;
					align-items: center;
					justify-content: center;

					text-align: center;

					color: #30343b;
					font-size: clamp(13px, 3.7vw, 17px);
					line-height: 1.15;
					font-weight: 700;

					display: -webkit-box;
					-webkit-line-clamp: 2;
					-webkit-box-orient: vertical;
					overflow: hidden;
				}

				/* ===== AUTH PANEL (1:1 din emag-ui-copy.html) ===== */

				.cs-auth-card {
					margin: 0 14px;
					background: #ffffff;
					border-radius: 17px;
					padding: 20px 14px 18px;
				}

				.cs-auth-copy {
					display: flex;
					align-items: center;
					gap: 12px;
					margin-bottom: 22px;
				}

				.cs-lock {
					flex-shrink: 0;

					width: 64px;
					height: 64px;

					display: flex;
					align-items: center;
					justify-content: center;

					border-radius: 50%;
					background: #eef4fb;
					color: #0788ee;
				}

				.cs-auth-copy h1 {
					margin: 0;
					color: #30343b;
					font-size: clamp(16px, 4.7vw, 22px);
					line-height: 1.3;
					font-weight: 800;
				}

				.cs-auth-button {
					width: 100%;
					height: 60px;

					border: 0;
					border-radius: 30px;

					background: #3b82f6;
					color: #ffffff;

					font-family: inherit;
					font-size: 17px;
					font-weight: 700;

					display: flex;
					align-items: center;
					justify-content: center;

					text-decoration: none;

					transition: background 0.18s ease;
				}

				.cs-auth-button:hover {
					background: #2563eb;
					color: #ffffff;
				}
			`}</style>

			<Swiper
				className='cs-swiper'
				modules={[FreeMode]}
				slidesPerView='auto'
				spaceBetween={10}
				freeMode={true}
				grabCursor={true}>
				{isPWA && (
					<SwiperSlide style={{ width: "auto" }}>
						<Link href='/toate-produsele' className='cs-card'>
							<div className='cs-visual'>
								<img src='/images/all-categories.webp' height='120' width='120' alt={t("toate_produsele")} loading='lazy' />
							</div>
							<div className='cs-title'>{t("toate_produsele")}</div>
						</Link>
					</SwiperSlide>
				)}
				{list.map((cat) => (
					<SwiperSlide key={cat.id} style={{ width: "auto" }}>
						<Link href={`/${cat.slug}`} className='cs-card'>
							<div className='cs-visual'>
								<img src={cat.image} height="120" width="120" alt={getCategoryVariable(cat)} loading='lazy' />
							</div>
							<div className='cs-title'>{getCategoryVariable(cat)}</div>
						</Link>
					</SwiperSlide>
				))}
			</Swiper>

			{!isLoggedIn && (
				<section className='cs-auth-card'>
					<div className='cs-auth-copy'>
				
                              <Image src='/images/password.webp' alt='' width={80} height={80} />
					
						<b>Autentifică-te și ai control deplin asupra comenzilor și ofertelor tale!</b>
					</div>

					<button onClick={() => window.location.href = "/autentificare"} className='cs-auth-button'>
						Autentificare / Cont nou
					</button>
				</section>
			)}
		</section>
	);
}
